import { stats } from '@fiverr-private/obs';

const PREFIX = 'packages.machine_translation_package';

export const count = (metric) => {
    stats.count(PREFIX, metric);
};
